import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 24px;
	border-radius: 8px;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
	background: #fff;
	margin: 8px;

	h3 {
		margin-bottom: 12px;
	}

	p {
		margin-bottom: 12px;
	}

	a {
		text-decoration: none;
		color: #000;
		font-weight: bold;

		&:hover {
			text-decoration: underline;
		}
	}
`;

